import { useEffect, useState } from 'react';
import Sheet from '@/components/ui/Sheet';

interface Props {
  aberto: boolean;
  nome: string;
  senhaAtual: string | null;
  salvando: boolean;
  erro: string | null;
  aoSalvar: (senha: string) => void;
  aoFechar: () => void;
}

// "Corrigir senha": uma entrada única, sempre em maiúsculas, para ajustar a
// senha de quem foi digitada errada na fila.
export default function FolhaCorrigirSenha({
  aberto,
  nome,
  senhaAtual,
  salvando,
  erro,
  aoSalvar,
  aoFechar,
}: Props) {
  const [valor, setValor] = useState('');

  useEffect(() => {
    if (aberto) setValor(senhaAtual ?? '');
  }, [aberto, senhaAtual]);

  const limpo = valor.trim().toUpperCase();

  return (
    <Sheet aberto={aberto} titulo="Corrigir senha" aoFechar={aoFechar}>
      <p className="text-[14px] text-foreground-600">
        Senha de{' '}
        <strong className="font-semibold text-foreground-900">{nome}</strong>
      </p>
      <input
        type="text"
        value={valor}
        onChange={(e) => setValor(e.target.value.toUpperCase())}
        placeholder="Ex.: M07"
        autoComplete="off"
        autoCapitalize="characters"
        maxLength={6}
        className="mt-3 h-14 w-full rounded-[16px] border border-background-200 bg-background-50 px-4 text-center font-mono text-[22px] font-extrabold uppercase tracking-widest text-foreground-950 placeholder:text-foreground-300 focus:border-primary-400 focus:outline-none"
      />
      {erro && <p className="mt-2 text-[14px] text-danger-600">{erro}</p>}
      <button
        type="button"
        disabled={salvando || limpo.length === 0}
        onClick={() => aoSalvar(limpo)}
        className="aperta mt-4 h-12 w-full cursor-pointer whitespace-nowrap rounded-[16px] bg-primary-500 text-[15px] font-bold text-white transition-colors hover:bg-primary-600 disabled:opacity-50"
      >
        {salvando ? 'Salvando…' : 'Salvar senha'}
      </button>
    </Sheet>
  );
}